export const GET_COUNTRIES_START = 'GET_COUNTRIES_START';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';
export const GET_COUNTRIES_END = 'GET_COUNTRIES_END';
export const GET_COUNTRIES_CLEAR = 'GET_COUNTRIES_CLEAR';
